import ProductAgreementsList from './ProductAgreementsList';

export default ProductAgreementsList;
